/*
 * @Description: 增加 ui 组件
 * @Author: luopeng
 * @Date: 2020-01-02 22:41:48
 * @LastEditors: luopeng
 * @LastEditTime: 2021-05-14 14:20:45
 */

// 导入ant组件
import './components_use';
import * as all from './mini';

export default all.default;
export const BasicInfo = all.BasicInfo;
export const FlowDesign = all.FlowDesign;
export const FlowSetting = all.FlowSetting;
export const flowStore = all.flowStore;



// WEBPACK FOOTER //
// ./src/components/packages/index.js